import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from 'src/app/shared/shared.module';
import { LucideAngularModule } from 'lucide-angular';

@Component({
	selector: 'app-welcome-card',
	templateUrl: './welcome-card.component.html',
	styleUrls: ['./welcome-card.component.scss'],
	imports: [MatCardModule, MatIconModule, SharedModule, LucideAngularModule],
	standalone: true
})
export class WelcomeCardComponent {
	@Input() userName: string | null = null;
	@Input() userCompany: string | null = null;
}
